<ul>
  @for (element of history.history; track element) {
    <li title="{{element.caption}}">
      <a [routerLink]="element.url">{{element.caption}}</a>
    </li>
  }
</ul>
